import { Injectable } from '@angular/core';
import { Util } from 'src/app/utils/utils';


@Injectable({
    providedIn: 'root'
})
export class StorageService{

    isItem(key: string): boolean{
        return localStorage.getItem(key) !== null;
    }

    read(key: string) {
        return localStorage.getItem(key);
    }

    write(key: string, value: any): void {
        localStorage.setItem(key, value);
    }

    remove(key: string): void {
        localStorage.removeItem(key);
    }

    clear(): void {
        localStorage.clear();
    }

    setItem(key: string, value: any, security?: boolean): void {
        let val = value;
        if (typeof value === 'object') {
            val = JSON.stringify(value);
        }
        if (security === true) {
            val = Util.encriptString(val);
        }
        localStorage.setItem(key, val);
    }

    getItem(key: string, security?: boolean): any | string | null {
        let item = localStorage.getItem(key);
        if (item !== null) {
            if (security === true) {
                item = Util.decriptString(item);
                if (item) {
                    item = item.trim();
                }
            }
            try {
                return JSON.parse(Util.sanityJSON(item));
            } catch (e) { }
        }
        return item;

    }
}